const APP_TOKEN_STORAGE = '@sigma-SGM';
const APP_LANGUAGE = '@sigma-SGM-Language';

/**
 * Funcion que almacena en el local storage el token de autorizacion para tomar los datos del API.
 * 
 * @param {string} sToken Token de autenticacion para los servicios
 * 
 * @author Leandro Curbelo
 */
export const setTokenLocalStorange = async (sToken) => {
    try {
        await localStorage.removeItem(APP_TOKEN_STORAGE);
        await localStorage.setItem(APP_TOKEN_STORAGE, sToken);
    } catch (oError) {
        throw oError;
    }
}
/**
 * Funcion que limpia el valor del token de autorizacion del local storage.
 * 
 * @author Leandro Curbelo
 */
export const setEmptyTokenLocalStorange = async () => {
    await localStorage.removeItem(APP_TOKEN_STORAGE);
}
/**
 * Funcion que toma del local storage el token de autorizacion.
 * 
 * @author Leandro Curbelo
 */
export const getTokenLocalStorange = async () => {
    return await localStorage.getItem(APP_TOKEN_STORAGE);
}
/**
 * Funcion que guarda el idioma establecido para el usuario en el local storage.
 * 
 * @author Leandro Curbelo
 */
export const setLanguageLocalStorange = async (sLanguage) => {
    await localStorage.removeItem(APP_LANGUAGE);
    await localStorage.setItem(APP_LANGUAGE, sLanguage);
}
/**
 * Funcion que toma el idioma establecido para el usuario desde el local storage.
 * 
 * @author Leandro Curbelo
 */
export const getLanguageLocalStorage = async () => {
    return await localStorage.getItem(APP_LANGUAGE);
}